module.exports = __webpack_public_path__ + "img/news_edit_brown.676e14bc.svg";